import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "iframe", "title"]

  open(event) {
    event.preventDefault()
    const vimeoUrl = event.currentTarget.dataset.videoUrl
    const title = event.currentTarget.dataset.videoTitle || "Video"

    if (vimeoUrl && this.hasIframeTarget) {
      // Convert vimeo URL to embed URL
      const embedUrl = this.toEmbedUrl(vimeoUrl)
      this.iframeTarget.src = embedUrl
    }

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = title
    }

    if (this.hasModalTarget) {
      this.modalTarget.showModal()
    }
  }

  close() {
    if (this.hasModalTarget) {
      this.modalTarget.close()
    }
    // Stop video playback
    if (this.hasIframeTarget) {
      this.iframeTarget.src = ""
    }
  }

  toEmbedUrl(url) {
    if (!url) return ""
    // Handle various Vimeo URL formats
    const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)
    if (match) {
      return `https://player.vimeo.com/video/${match[1]}?autoplay=1&title=0&byline=0&portrait=0`
    }
    // Already an embed URL
    if (url.includes("player.vimeo.com")) {
      return url.includes("autoplay") ? url : `${url}?autoplay=1`
    }
    return url
  }
}
